import { Provider } from 'react-redux';
import React from 'react';
import store from '../../store';
import AppRouter from '../../router';

const App = () => {
  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
};

export default App;
